<p-toast [baseZIndex]="999999999"></p-toast>
<p-confirmDialog></p-confirmDialog>
<p-dialog [visible]="loading" [style]="{minWidth: '12vw'}" [header]="'Procesando Contactos, por favor espere...'" [modal]="true" [closable]="false" appendTo="body" position="top">
    <div class="flex justify-content-center flex-wrap">
        <p-progressSpinner></p-progressSpinner>
    </div>
</p-dialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <h5>Importar Contactos</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup">
                <div class="field col-12 md:col-3">
                    <p-button label="Formato Excel" (click)="onImport()"></p-button>
                </div>
            </form>
            <p-fileUpload name="contactos[]" (onUpload)="cargarArchivo($event)" maxFileSize="130000000" [chooseLabel]="'Cargar Archivo'" accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                customUpload="true" (uploadHandler)="procesarArchivo($event)" [uploadLabel]="'Importar Contactos'" [uploadIcon]="'pi pi-send'" [cancelLabel]="'Cancelar'"
                (onSelect)="onSelect($event)">
                <ng-template pTemplate="content">
                    <ul *ngIf="uploadedFiles?.length">
                        <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                    </ul>
                </ng-template>
            </p-fileUpload>
            <div class="grid pt-5">
                <div class="col-12 md:col-3">
                    <label><b>Contactos Creados: {{ creados }}</b></label>
                </div>
                <div class="col-12 md:col-3">
                    <label><b>Contactos Actualizados: {{ actualizados }}</b></label>
                </div>
                <div class="col-12 md:col-3">
                    <label><b>Error: {{ error }}</b></label>
                </div>
            </div>
            <div class="grid">
                <div class="col-12">
                    <label><b>Mensajes de error: {{ msg_error }}</b></label>
                </div>
            </div>
        </div>
    </div>
</div>


<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista"
    (close)="cerrarOnLista($event)">
</app-on-lista>